import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { RxCross2 } from "react-icons/rx";
import AOS from "aos";
import "aos/dist/aos.css";
import { VscTools } from "react-icons/vsc";

const products = [
  {
    id: 1,
    name: "MCT MCRS",
    desc: "Enterprise Cyber Governance, Risk & Compliance Platform.",
    route: "/mct_grc",
  },
  {
    id: 2,
    name: "Inventory Management",
    desc: "Master Your Stock: Know What You Have and Where It Is.",
    route: "/mct_inventory_management",
  },
  {
    id: 3,
    name: "Document Management System",
    desc: "Web-based Document Management System.",
    route: "/mct_dms",
  },
  {
    id: 4,
    name: "Help Desk",
    desc: "Emerges as a cutting-edge web solution.",
    route: "/mct_helpdesk",
  },
];

function ResBar({ show, setShow }) {
  const navigate = useNavigate();
  const [openSaaS, setOpenSaaS] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 500 });
  }, []);

  return show ? (
    <div
      data-aos="right"
      className="res-bar w-full fixed  p-4 h-full  z-20 flex flex-col "
      style={{ left: "0%" }}
    >
      <RxCross2
        onClick={() => setShow(false)}
        className="text-white text-3xl tpo-4 absolute right-6"
      />
      <Link
        onClick={() => setShow(false)}
        to="/"
        className="px-5 py-3 text-white"
      >
        Home
      </Link>
      <Link
        onClick={() => setShow(false)}
        to="/productpage"
        className="px-5 py-3 text-white"
      >
        Products
      </Link>
      <Link
        onClick={() => setShow(false)}
        to="/about"
        className="px-5 py-3 text-white"
      >
        About Us
      </Link>
      <Link
        onClick={() => setShow(false)}
        to="/services"
        className="px-5 py-3 text-white"
      >
        Service
      </Link>
      
      <Link
        onClick={() => setShow(false)}
        to="/contactpage"
        className="px-5 py-3 text-white"
      >
        Contact Us
      </Link>
      <Link
        onClick={() => setShow(false)}
        to="/faq_"
        className="px-5 py-3 text-white"
      >
        FAQ
      </Link>
      <Link
        onClick={() => setShow(false)}
        to="/blog"
        className="px-5 py-3 text-white"
      >
        Blog
      </Link>
      <Link
        onClick={() => setShow(false)}
        to="/privacy_policy"
        className="px-5 py-3 text-white"
      >
       Privacy Policy
      </Link>
        {/* SaaS Products */}
        <div className="mt-4">
          <button
            onClick={() => setOpenSaaS((prev) => !prev)}
            className="w-full text-left text-white font-semibold py-2 border-t border-gray-700 flex justify-between items-center"
          >
            SaaS Products
            <span>{openSaaS ? "-" : "+"}</span>
          </button>

          {openSaaS && (
            <div className="flex flex-col gap-3 mt-2">
              {products.map((product) => (
                <div
                  key={product.id}
                  onClick={() => {
                    navigate(product.route);
                    setShow(false);
                  }}
                  className="flex items-start gap-3 p-2 rounded hover:bg-gray-800 cursor-pointer transition"
                >
                  <VscTools className="text-white text-3xl p-1 rounded-full border border-gray-500" />
                  <div>
                    <p className="text-white font-medium">{product.name}</p>
                    <p className="text-gray-400 text-sm">{product.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
    </div>
  ) : (
    <div
      data-aos="right"
      className="res-bar w-full fixed  p-4 h-full  z-10 flex flex-col "
      style={{ left: "-100%" }}
    >
      <RxCross2
        onClick={() => setShow(false)}
        className="text-white text-3xl absolute right-6"
      />
      
      <Link className="px-5 py-3 text-white">Home</Link>
      <Link className="px-5 py-3 text-white">Products</Link>
      <Link className="px-5 py-3 text-white">About Us</Link>
      <Link className="px-5 py-3 text-white">Service</Link>
      <Link className="px-5 py-3 text-white">Contact Us</Link>
    </div>
  );
}

export default ResBar;
